import React, { Component } from "react";

import text_mayu from "../../Images/text_mayu.png";

import "./ShipiboConibo.scss";
import Tooltip from "../../Components/Tooltip";

class ShipiboConibo extends Component {
  render() {
    return (
      <div className="shipibo-conibo">
        <div className="intro">
          <img src={text_mayu} alt="Introductie" />
          <span>
            Dit is mijn dorp. Mooi he?<br /> Kijk eens goed naar de foto, wat valt
            jullie op? <br/>Zijn er dingen anders dan bij jullie? Waarom zou dat zo
            zijn?
          </span>
        </div>
        <Tooltip />
      </div>
    );
  }
}

export default ShipiboConibo;
